import React from 'react';

import css from './TopbarSearchForm.module.css';

const IconSearchDesktop = () => (
  <svg
    className={css.iconSvg}
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    fill="none"
    viewBox="0 0 26 26"
  >
    <path
      className={css.iconSvgGroup}
      stroke="#E6E4FF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m25 25-5.79-5.79m0 0A10.667 10.667 0 1 0 4.122 4.123 10.667 10.667 0 0 0 19.21 19.209"
    ></path>
  </svg>
);

export default IconSearchDesktop;
